// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Book-container-ZY6m3 {
  max-width: var(--max-container-width);
  margin: 40px auto 0 auto;
}

.Book-landingContainer-c9BTS {
  width: 100%;
  display: block;
  margin: 0 auto;
}

@media screen and (max-width:767px) {
  .Book-overFlowHiddenMobile-oUQIj {
    overflow-x: hidden;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/book/Book.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".container {\n  max-width: var(--max-container-width);\n  margin: 40px auto 0 auto;\n}\n\n.landingContainer {\n  width: 100%;\n  display: block;\n  margin: 0 auto;\n}\n\n@media screen and (max-width:767px) {\n  .overFlowHiddenMobile {\n    overflow-x: hidden;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Book-container-ZY6m3`,
	"landingContainer": `Book-landingContainer-c9BTS`,
	"overFlowHiddenMobile": `Book-overFlowHiddenMobile-oUQIj`
};
module.exports = ___CSS_LOADER_EXPORT___;
